import React from "react";

// why: 문의사항 접수/FAQ 등의 콘텐츠를 위한 독립 페이지 스켈레톤

const SupportQuestions = () => {
  return (
    <main className="page-sub">
      <h2>문의사항</h2>
    </main>
  );
};

export default SupportQuestions;


